<p><strong>Hi {{ username }},</strong></p>
            <p>I noticed you stopped by {{ sitename | formatSitename}} earlier today — just wanted to say a quick hello 👋</p>
            <p>I'm Sarah, part of the support team here. If you ever have a question about academic writing, managing deadlines, or how our services work — feel free to reply anytime. No pressure — just here to help if you need it.</p>
            <p>Wishing you a productive rest of your week!</p>
            <p>Warmly,<br>Sarah</p>
            <br>
            <hr style="width:100%; border:0; height:1px; background:rgba(0, 123, 255, 0.2);">
 
            <table cellpadding="0" cellspacing="0" width="100%" style="padding-top: 20px;">
                <tr>
                    <td width="100" align="left" valign="top" style="padding-right: 10px;">
                        <img src="https://backend.skyscrapersnow.com/images/sarah.png" alt="Sarah A." width="97" height="124" style="border-radius: 8px; display: block;">
                    </td>
                    <td align="left" valign="top" style="font-family: Arial, sans-serif; font-size: 14px; color: #333;">
                         <img src="https://backend.skyscrapersnow.com/images/sarah_sign.png" alt="Kate A Signature" style="max-width: 82px;
    max-height: 34px;
    display: block;
    margin-bottom: 5px;">
                        <p style="font-weight: 500;
    font-size: 18px;
    color: #000000;

    text-align: left;
    margin: 0;">Sarah A.</p>
                        <p style="margin: 7px 0;
    color: #767E8C;
    font-size: 13px;
    text-align: left;">Student Support Specialist</p>
                        <table cellpadding="0" cellspacing="0" border="0">
                            <tr>
                                <td valign="middle" style="padding: 0px;">
                                    <img src="https://backend.skyscrapersnow.com/images/globe.png" alt="Website" width="15" height="15" style="display: block;">
                                </td>
                                <td valign="middle" style="font-size: 13px;color: #767E8C; padding: 0px 0px 0px 5px;">
                                    <a href="https://'.$site_link_clean.'" style="color: #767E8C; text-decoration: none;">{{ sitename }}</a>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
            </table>